import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table, Spin } from "antd";

import ExperienceRow from "./ExperienceRow";
import InsuranceUploader from "./InsuranceUploader";
import useWorkExperienceData from "../../../../../custom-hooks/useWorkExperienceData";
import { getRequest } from "../../../../../api/http";
import userServiceApi from "../../../../../api/userServiceApi";
import { contactUSkeys, TAB_KEYS } from "../../../../../config";
import { toast } from "react-toastify";
import "./WorkExperience.scss";
import EmptyTabWarning from "../../../../common/EmptyTabWarning";
import { usePublishedEmptyTabWarning } from "../../../../../custom-hooks/usePublishedEmptyTabWarning";

export default function WorkExperienceNew({ handleTabs, getSingleTabData }) {
  const { micrositeId } = useParams();
  const {
    finalData,
    setFinalData,
    loader,
    uploadProps,
    existingFiles,
    handleDeleteFile,
    eofRecords,
  } = useWorkExperienceData(micrositeId);
  const [eofOpportunityTitle, setEofOpportunityTitle] = useState(null);
  const { show: showEmptyTabWarning, tabName: emptyTabName } =
    usePublishedEmptyTabWarning({
      tabKey: TAB_KEYS.workExperience,
      fallbackName: "Experiences of work",
      data: eofRecords,
      loaded: !loader && eofRecords !== undefined,
    });

  const getEofOpportunityTitles = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getMasterDataType("WORK_OPPORTUNITY_TITLE")
      );
      if (response) {
        setEofOpportunityTitle(response);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    getEofOpportunityTitles();
    if (getSingleTabData) {
      getSingleTabData(contactUSkeys.eow);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [micrositeId]);

  if (loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  const columns = [
    {
      title: "",
      dataIndex: "experienceOfWorkTitle",
      key: "experienceOfWorkID",
      render: (value) => <b>{value}</b>,
    },
    {
      title: "Virtual Opportunities",
      dataIndex: "virtual",
      key: "virtual",
      className: "table-headers",
      render: (_, record, index) => (
        <ExperienceRow
          record={record}
          index={index}
          type="VIRTUAL"
          key={`virtual-${index}`}
          finalData={finalData}
          setFinalData={setFinalData}
          eofOpportunityTitle={eofOpportunityTitle}
          handleTabs={handleTabs}
        />
      ),
    },
    {
      title: "Face to Face Opportunities",
      dataIndex: "faceToFace",
      key: "faceToFace",
      className: "table-headers",
      render: (_, record, index) => (
        <ExperienceRow
          record={record}
          index={index}
          type="FACE_TO_FACE"
          key={`face-${index}`}
          finalData={finalData}
          setFinalData={setFinalData}
          eofOpportunityTitle={eofOpportunityTitle}
          handleTabs={handleTabs}
        />
      ),
    },
  ];

  return (
    <div>
      {showEmptyTabWarning && <EmptyTabWarning tabName={emptyTabName} />}
      <InsuranceUploader
        uploadProps={uploadProps}
        existingFiles={existingFiles}
        handleDeleteFile={handleDeleteFile}
      />
      <h2 style={{
        marginBottom: "20px",
        marginLeft: "6px",
        textAlign: "center",
        fontWeight: 'bold'
      }}>Attracting future talent via Student engagement </h2>
      <Table
        pagination={false}
        columns={columns}
        dataSource={finalData}
        rowKey="experienceOfWorkID"
      />
    </div>
  );
}
